import { Container, IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { ShopItem } from "../model/ShopItem";
import { ShopResourcePackage } from "../resources/ShopResourcePackage";
import { HBox } from "../../../common/components/ui/HBox";
import { Event } from "event-system";

export class MonShopItemContainer extends Container {
    public readonly onMonPackageClick: Event;

    private marketplaceCardClicked: boolean;
    private downMousePosY: number;

    public constructor(
        private readonly shopResources: ShopResourcePackage,
        private readonly shopItemData: ShopItem
    ) {
        super();
        this.onMonPackageClick = new Event();
        this.build();
        this.on("pointerdown", this.cardTouchStartHandle, this);
        this.on("pointerup", this.cardTouchEndHandle, this);
        this.on("pointermove", this.cardTouchMoveHandle, this);
    }

    private build(): void {
        const background = new Sprite(this.shopResources.assets_views_shop_glass_long_png);
        const shape = new Sprite(this.shopResources.assets_views_shop_snape_yelow_long_png);
        shape.position.set(background.width - shape.width, 0);

        const diceBox = new HBox(20);
        const diceIcon = new Sprite(this.shopResources.assets_views_shop_dice_icon_png);
        const diceCountText = new Text(this.shopItemData.reward.diceRolls, new DefaultTextStyle());
        diceBox.addChild(diceIcon, diceCountText);
        diceCountText.position.y = diceIcon.height * 0.5 - diceCountText.height * 0.5 + 7;
        diceBox.position.set(background.width * 0.25 - diceBox.width * 0.5 - 10, background.height * 0.5 - diceBox.height * 0.5 + 5);

        const monBox = new HBox(0);
        const monPriceText = new Text(this.shopItemData.price, new DefaultTextStyle());
        monPriceText.style.fill = "#000000"
        const monPriceIcon = new Sprite(this.shopResources.assets_views_shop_mon_icon_png);
        monBox.addChild(monPriceText, monPriceIcon);
        monPriceText.position.y = monPriceIcon.height * 0.5 - monPriceText.height * 0.5 + 7;
        monBox.position.set(background.width * 0.75 - monBox.width * 0.5 - 16, background.height * 0.5 - monBox.height * 0.5 + 7);

        this.addChild(
            background,
            shape,
            diceBox,
            monBox
        );
    }

    private async cardTouchStartHandle(event: any): Promise<void> {
        this.marketplaceCardClicked = true;
        this.downMousePosY = Math.ceil(event.data.global.y);
    }

    private async cardTouchMoveHandle(event: any): Promise<void> {
        let currentMousePosY: number = Math.ceil(event.data.global.y);
        if (Math.abs(this.downMousePosY - currentMousePosY) > 20) {
            this.marketplaceCardClicked = false;
        }
    }

    private async cardTouchEndHandle(): Promise<void> {
        if (this.marketplaceCardClicked) {
            this.onMonPackageClick.emit();
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.off("pointerdown", this.cardTouchStartHandle, this);
        this.off("pointerup", this.cardTouchEndHandle, this);
        this.off("pointermove", this.cardTouchMoveHandle, this);
        super.destroy(options);
    }
}

class DefaultTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            dropShadow: true,
            dropShadowAlpha: 0.2,
            dropShadowAngle: 0.9,
            dropShadowBlur: 5
        }));
    }
}
